import * as React from "react";
import type { SVGProps } from "react";

const SvgDrawerCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.46.36c.48.48.48 1.26 0 1.74L2.38 17.179c-.48.48-1.26.48-1.74 0s-.48-1.26 0-1.74L15.721.359a1.23 1.23 0 0 1 1.738 0m-5.701 9.66 5.42 5.419a1.23 1.23 0 1 1-1.74 1.74l-5.42-5.42zM.359.36C.84-.12 1.62-.12 2.1.36l5.46 5.46-1.74 1.74L.36 2.1C-.12 1.62-.12.84.36.36"
    />
  </svg>
);
export default SvgDrawerCloseIcon;
